import styled from 'styled-components'


export const ReplyContainer = styled.div`
// background-color: #f1f1f1;
width: 100%;
display: flex;
align-items: center;
justify-content: right;
align-self: right;
margin-top: 5px;
padding: 3px;
border: none;
border-radius: 3px;
`;
export const ImageHolder = styled.div`
border: none;
height: 20px;
width: 20px;
border-radius: 50px;
margin-right: 4px;
`;

export const Greeting = styled.div`
color: #00A3FF;
margin-right: 4px;
font-size: 12px;
`;
export const Emoji = styled.div`
color: #00A3FF;
font-size: 12px;
`;
// export const ddddd = styled.div``;
// export const ddddd = styled.div``;
// export const ddddd = styled.div``;